import React, { useState, useEffect } from 'react';
import { Plus, Video, AlertCircle, Trash2, Edit3 } from 'lucide-react';
import NewsForm from './NewsForm';
import '../../../styles/AdminNews.css';
import { collection, query, orderBy, onSnapshot, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebase.js';
import DOMPurify from 'dompurify';

const AdminNews = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'news'), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(q, (snap) => {
      const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setNews(items);
      setLoading(false);
    }, (err) => {
      console.error('Error leyendo noticias:', err);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return (
    <div className="admin-news-section">
      <header className="admin-news-header">
        <h2><Video size={20}/> Anuncios y Noticias</h2>
        <button className="admin-news-add-btn" onClick={() => setShowForm(true)}>
          <Plus size={16}/> Nuevo anuncio
        </button>
      </header>
      {showForm && <NewsForm newsItem={editingItem} onSaved={() => { setShowForm(false); setEditingItem(null); }} onCancel={() => { setShowForm(false); setEditingItem(null); }} />}
      {loading ? (
        <div className="admin-news-empty">Cargando...</div>
      ) : (
        <>
          <div className="admin-news-list">
            {news.map(item => (
              <div key={item.id} className="admin-news-row">
                <div style={{flex:1}}>
                  <h4 style={{margin:0}}>{item.title}</h4>
                  <div style={{margin:'8px 0 0 0', color:'var(--color-texto-input)'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content || '') }} />
                  <div style={{marginTop:8}} className="news-date">{(item.createdAt && item.createdAt.toDate) ? item.createdAt.toDate().toLocaleString() : (item.createdAt instanceof Date ? item.createdAt.toLocaleString() : '')}</div>
                </div>
                <div style={{marginLeft:12, display:'flex', gap:8}}>
                  <button className="admin-news-action" onClick={() => { setEditingItem(item); setShowForm(true); }} title="Editar"><Edit3 size={16} /></button>
                  <button className="admin-news-action danger" onClick={async () => {
                    if (!window.confirm('¿Eliminar esta noticia? Esta acción no se puede deshacer.')) return;
                    try {
                      await deleteDoc(doc(db, 'news', item.id));
                    } catch (e) {
                      console.error('Error eliminando noticia:', e);
                      alert('Error eliminando la noticia. Revisa la consola para más detalles.');
                    }
                  }} title="Eliminar"><Trash2 size={16} /></button>
                </div>
              </div>
            ))}
          </div>
          {news.length === 0 && (
            <div className="admin-news-empty">
              <AlertCircle size={32}/>
              <p>No hay anuncios publicados.</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AdminNews;
